import React, { useEffect, useState } from "react";
import {
  Github,
  Linkedin,
  Instagram,
  Mail,
  Facebook,
} from "lucide-react";
import classes from "./contact.module.css";

// Custom X Logo for Twitter (X)
const XLogo = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.0960V13.0956Z" />
  </svg>
);

// Custom Discord Logo
const DiscordLogo = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
  </svg>
);

const SocialLinks = () => {
  const [emailLink, setEmailLink] = useState("#");

  useEffect(() => {
    const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
    const email = "viveksharma.vs0615@gmail.com";
    const subject = encodeURIComponent("Let's Connect");
    const body = encodeURIComponent("Hi Vivek, I wanted to reach out...");

    if (isMobile) {
      // Mobile: open in default mail app
      setEmailLink(`mailto:${email}?subject=${subject}&body=${body}`);
    } else {
      // Desktop: open Gmail web compose
      setEmailLink(
        `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`
      );
    }
  }, []);

  const socialLinks = [
    {
      name: "Email",
      icon: Mail,
      url: emailLink,
      className: classes.email,
    },
    {
      name: "LinkedIn",
      icon: Linkedin,
      url: "https://www.linkedin.com/in/vivek-sharma-a6bb2b2b7/",
      className: classes.linkedin,
    },
    {
      name: "GitHub",
      icon: Github,
      url: "https://github.com/Codester06",
      className: classes.github,
    },
    {
      name: "Discord",
      icon: DiscordLogo,
      url: "https://discord.gg/QCm4A2vW", // Replace with your Discord server invite or profile
      className: classes.discord,
    },
    {
      name: "Twitter",
      icon: XLogo,
      url: "https://x.com/VivekkShxrma",
      className: classes.twitter,
    },
    {
      name: "Instagram",
      icon: Instagram,
      url: "https://www.instagram.com/vivekshxrma.me/",
      className: classes.instagram,
    },
    {
      name: "Facebook",
      icon: Facebook,
      url: "https://www.facebook.com/Codester06",
      className: classes.facebook,
    },
  ];

  return (
    <div className={classes.LinkContainer}>
      <button className={classes.headingLink}>LET'S CONNECT!</button>

      <ul className={classes.socialGrid}>
        {socialLinks.map((link, index) => {
          const IconComponent = link.icon;
          return (
            <li key={index}>
              <a
                href={link.url}
                className={`${classes.socialLink} ${link.className}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className={classes.iconWrapper}>
                  <IconComponent size={20} />
                </span>
                <span className={classes.linkText}>{link.name}</span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SocialLinks;